import { defineAsyncComponent } from "vue";
import { defineColumnInterface } from "../../lib/defines";

export default defineColumnInterface({
  id: "default",
  component: defineAsyncComponent(() => import("./column-default.vue")),
});
